import React from 'react';
import {Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend} from 'chart.js';
import {Line} from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

/**
 * LineChart component
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const LineChart = (props) => {
    const {labels, dataset, title} = props;

    const data = {
        labels: labels,
        datasets: [
            {
                data: dataset,
                backgroundColor: 'rgb(165, 30, 55)',
            },
        ],
    }

    const options = {
        scales: {
            y: {
                beginAtZero: true,
            },
            x: {
                grid: {
                    display: false,
                }
            }
        },
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                position: 'top',
                color: 'black',
                text: title,
                font: {
                    size: 20,
                    family: "work-Sans, sans-serif",
                }
            },
        }
    }

    return <Line data={data} options={options}/>
}

export default LineChart;
